<template>
  <div class="page">
    <div class="page-title">編輯用戶帳號</div>
    <div class="form-box">
      <userFrom
        @addSubscription="addSubscription"
        :form="form"
        ref="form"
        :isEdit="true"
      ></userFrom>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type="success" @click="onBackUser">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { putUser, getUserDetail } from "@/api/users";
import userFrom from "./components/userFrom.vue";
export default {
  components: { userFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        userNo: null,
        name: null,
        gender: 0,
        email: null,
        password: null,
        confirmPassword: null,
        areaCode: null,
        phone: null,
        roleId: 4,
        avatar: null,
        country: null,
        area: null,
        district: null,
        address: null,
        students: [
          {
            userNo: null,
            status: 0,
            name: null,
            gender: null,
            branchSchool: {
              id: null,
              name: {
                en: null,
                zhTc: null,
              },
              abbreviation: null,
            },
            password: null,
            confirmPassword: null,
            subscription: [],
            grade: {
              name: null,
              price: 0,
            },
            avatar: null,
            birthday: null,
            studentCode: null,
          },
        ],
      },
    };
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    onSubmit() {
      this.$refs.form.$refs.form.validate((valid) => {
        if (valid) {
          this.putUser();
        }
      });
    },
    addSubscription() {
      this.getUserDetail();
    },
    getUserDetail() {
      getUserDetail(this.id).then((v) => {
        this.form = v.data;
        this.form.confirmPassword = this.form.password;
        this.form.students.map((item) => {
          if (item.branchSchool == null) {
            item.branchSchool = {
              id: null,
            };
          }
          if (item.grade == null) {
            item.grade = {
              id: null,
            };
          }
          item.confirmPassword = item.password;
          return item;
        });
      });
    },
    putUser() {
      this.form.userNo = this.form.email
      putUser(this.id, this.form).then(() => {
         this.$message.success("修改成功");
         this.onBackUser()
      });
    },
    onBackUser() {
      let path = ``
      if(this.$route.meta.name === '/studentEdit'){
        path = `/student`
        // this.resolveRouter(path)
        this.$router.push({path: path})
      }else{
        path = `/user`
        // this.resolveRouter(path)
        this.$router.push({path: path})
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-box {
  margin-top: 20px;
  overflow: hidden;
  background-color: #fff;
  padding: 20px;
  
}
</style>